import { useRef, useState } from "react";
import Layout from "../component/Layout/Layout";

export default function TryOn() {
  const [isOpen, setIsOpen] = useState(false);
  const [preview, setPreview] = useState(null);
  const [confirmed, setConfirmed] = useState(false);
  const fileInputRef = useRef(null);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const handleAreaClick = () => {
    if (!preview) {
      fileInputRef.current.click();
    }
  };

  const handleFile = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setPreview(URL.createObjectURL(file));
    setConfirmed(false);
  };

  const handleUsePhoto = () => {
    setConfirmed(true);
    console.log("👉 Send image to API");
  };

  const handleTryAnother = () => {
    setPreview(null);
    setConfirmed(false);
    fileInputRef.current.value = "";
  };

  return (
    <>
      <Layout title="Try On : Chaashni By MK" description="Chaashni Couture By : Description">

        {/* Trigger Button */}
        <div className="tryon-wrap">
          <button onClick={openModal} className="open-btn">
            Try the Look
          </button>
        </div>

        {/* Modal */}
        {isOpen && (
          <div className={`tryon-popup modal-overlay ${confirmed ? "active-tryon" : ""}`}>
            <div className="modal-overlay-box" onClick={closeModal}></div>

            <div className="modal-box">

              {/* Header */}
              <div className="modal-header">
                <span>Chaashni By MK – Personalized Digital Fittings</span>
                <span className="close-btn" onClick={closeModal}>×</span>
              </div>

              {/* Upload Area */}
              <div className="upload-area" onClick={handleAreaClick}>

                <input
                  type="file"
                  ref={fileInputRef}
                  accept="image/*"
                  capture="environment"
                  onChange={handleFile}
                  style={{ display: "none" }}
                />

                {!preview ? (
                  <>
                    <div className="upload-icon">
                      <i className="fa-solid fa-cloud-arrow-up"></i>
                    </div>
                    <p>Click anywhere to upload a full body photo</p>
                  </>
                ) : (
                  <>
                    <img src={preview} alt="preview" className="preview" />

                    {/* Buttons */}
                    {!confirmed && (
                      <div className="btn-group">
                        <button
                          className="use-btn"
                          onClick={handleUsePhoto}
                        >
                          Use This Photo
                        </button>

                        <button
                          className="retry-btn"
                          onClick={handleTryAnother}
                        >
                          Try Another
                        </button>
                      </div>
                    )}

                    {confirmed && (
                      <div className="success-text-box">
                      <p className="success-text">✅ Photo selected</p>
                      </div>
                    )}
                  </>
                )}

              </div>

            </div>
          </div>
        )}
      </Layout>
    </>
  );
}